import Footer from '@tcs/create-account/components/Footer';
import Header from '@tcs/create-account/components/Header';
import Steps from '@tcs/create-account/components/Steps';
import useConfig from '@tcs/create-account/hooks/useConfig';
import useCustomer from '@tcs/create-account/hooks/useCustomer';
import useFeature, { FeatureFlag } from '@tcs/create-account/hooks/useFeature';
import usePartnerConfig from '@tcs/create-account/hooks/usePartnerConfig';
import { useMemo } from 'react';
import { useParams } from 'react-router';
import { useSearchParams } from 'react-router-dom';

export const StepsPage: React.FC<{
  partnerId?: string;
  sessionEnabled?: boolean;
}> = ({ partnerId, sessionEnabled = false }) => {
  const params = useParams();
  const [searchParams] = useSearchParams();

  const { loading, data: partnerConfig } = usePartnerConfig(
    params.partnerId ?? partnerId,
    params.representativeCode
  );

  const { loading: loadingCustomer, data: customer } =
    useCustomer(sessionEnabled);

  const promoCode = useMemo(() => {
    return (
      customer?.promoCode ??
      partnerConfig?.promoCode ??
      searchParams.get('promoCode')
    );
  }, [searchParams, partnerConfig, customer]);

  const config = useConfig();

  const hideChat = !useFeature(FeatureFlag.EnableChat);

  if (loading || loadingCustomer) {
    return null;
  }

  return (
    <>
      <Header data={partnerConfig?.header} />
      <Steps
        loading={loading}
        {...partnerConfig}
        promoCode={promoCode}
        customer={customer}
        representativeCode={params.representativeCode}
        allowDebug={config.PUBLIC_ALLOW_DEBUG === 'true'}
        serviceHost={config.PUBLIC_SERVICE_HOST}
        apiKey={partnerConfig?.apiKey ?? config.PUBLIC_API_KEY}
        apiSecret={partnerConfig?.apiSecret ?? config.PUBLIC_API_SECRET}
        hideChat={hideChat}
      />
      <Footer data={partnerConfig?.footer} />
    </>
  );
};

export default StepsPage;
